<template>
  <div id="category-tabs">
    <div class="selected-category">
      <span>Requests:</span>
      <span class="green">{{selectedCategory}}</span>
    </div>
    <div v-if="global.screenWidth > 800" class="category-controls">
      <div
        v-for="(categoryKey, index) in categories"
        :key="'categorycontrol'+index"
        :class="selectedCategory === categoryKey ? 'active' : ''"
        @click="selectedCategory = categoryKey"
      >{{categoryKey}}</div>
    </div>

    <Dropdown
      v-else
      :className="'dashboard-dd'"
      :options="mobileCategories"
      :initialItem="mobileCategories.find( (category) => category.key === initialCategory)"
      @itemselected="(newCategory) =>  selectedCategory = newCategory.key"
    />
    <div>
      <AccordionController
        :data="{title: '', type: accountType, items: sortedData[selectedCategory]}"
        :selectedCategory="selectedCategory"
      />
    </div>
  </div>
</template>

<script>
// v-if="selectedCategory && data[selectedCategory]"
import AccordionController from "@/components/global/Accordion/AccordionController";
import Dropdown from "@/components/global/Dropdown";
import { mapState } from "vuex";
export default {
  name: "CategoryTabs",
  components: {
    AccordionController,
    Dropdown,
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
    sortedData: {
      type: Object,
      required: true,
    },
    initialCategory: {
      type: String,
      required: true,
    },
    accountType: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(["global"]),
  },
  data() {
    //data will be moved to request soon. this is a temp example
    return {
      selectedCategory: "",
      mobileCategories: [],
    };
  },
  mounted() {
    this.selectedCategory = this.initialCategory;
    this.mobileCategories = this.categories.map((category) => {
      return { label: category, key: category };
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
#category-tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: flex-start;
  padding: 15px 30px 15px 15px;
  @media (max-width: $lg) {
    margin-top: 0;
  }
  .selected-category {
    font-size: 18px;
    color: #8b8795;
    letter-spacing: 0;
    padding-left: 25px;
    margin-bottom: 15px;
    .green {
      color: #2ec693;
    }
  }
  .category-controls {
    min-height: 68px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    margin-bottom: 80px;
    border-bottom: 2px solid #efefef;
    width: 100%;
    > div {
      font-size: 14px;
      color: #8b8795;
      letter-spacing: 0;
      font-weight: 700;
      background: #ffffff;
      border-bottom: 2px solid #efefef;

      padding: 7px 15px;
      flex: 1;

      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.2s ease-in-out;
      max-width: 10%;
      &:hover {
        cursor: pointer;
        border-bottom: 2px solid #8b8795;
      }
    }
    .active {
      border-bottom: 2px solid #8b8795;
      &:hover {
      }
    }
  }
}
</style>

